module.exports = __webpack_public_path__ + "static/media/gluten.07f464f9.png";